import Vue from 'vue'
import Router from 'vue-router'
import Config from '../../config/index.js'
//测试页面
import Test from '@/page/Test/Test'
//  登录
import Login from '@/page/login/login'
//  首页
import Home from '@/page/home/home'
//  借用列表
import BorrowList from '@/page/borrowList/borrowList'
//  借用详情
import BorrowDetails from '@/page/borrowDetails/borrowDetails'
//借用审批列表
import DeployBorrowListAuditList from '@/page/DeployBorrowAudit/DeployBorrowListAuditList'
//借用审批详情
import DeployBorrowAuditDefault from '@/page/DeployBorrowAuditDefault/DeployBorrowAuditDefault'
//  归还列表
import DeployGiveList from '@/page/DeployGiveList/DeployGiveList'
//归还详情列表
import DeployGiveDefault from '@/page/DeployGiveDefault/DeployGiveDefault'
//归还审核列表
import DeployGiveListAuditList from '@/page/DeployGiveListAuditList/DeployGiveListAuditList'
//归还审核详情
import DeployGiveAuditDefault from '@/page/DeployGiveAuditDefault/DeployGiveAuditDefault'
//  资产查询
import PropertySearch from '../page/propertySearch/propertySearch'
//  资产详细
import PropertyDetails from '../page/propertyDetails/propertyDetails'
//  报修
import Repairs from '../page/repairs/repairs'
//  搜索问题
import QuestionSearch from '../page/questionSearch/questionSearch'
//  科室报修
import RepairsList from '../page/repairsList/repairsList'
//  维修管理
import MaintenanceManagement from '../page/maintenanceManagement/maintenanceManagement'
//  派工/已派工
import DispatchList from '../page/dispatchList/dispatchList'
//  转单列表
import TransferOrderList from '../page/transferOrderList/transferOrderList'
//  转单
import TransferOrder from '../page/transferOrder/transferOrder'
//  接单列表
import OrderReceivingList from '../page/orderReceivingList/orderReceivingList'
//  验收列表
import ExamineReceiveList from '../page/examineReceiveList/examineReceiveList'
//  维修列表
import ServiceList from '../page/serviceList/serviceList'
//  我的审批
import ExamineList from '../page/examineList/examineList'
//  资产档案
import PropertyRecord from '../page/propertyRecord/propertyRecord'
//  资产图片上传
import PropertyUploadImg from '../page/propertyUploadImg/propertyUploadImg'
//  资产报废
import Scrap from '../page/scrap/scrap'
//  资产报废列表
import ScrapList from '../page/scrapList/scrapList'
//  资产转科
import ChangeDepartment from '../page/changeDepartment/changeDepartment'
//  资产转科列表
import ChangeDepartmentList from '../page/changeDepartmentList/changeDepartmentList'
//  合同附件
import Accessory from '../page/accessory/accessory'
//  合同附件列表
import AccessoryList from '../page/accessoryList/accessoryList'
//  进度查询
import MaintenanceProgress from '../page/maintenanceProgress/maintenanceProgress'
//  维修进度列表
import MaintenanceProgressList from '../page/maintenanceProgressList/maintenanceProgressList'
//  预防计划实施
import Prevent from '../page/prevent/prevent'
//  质量检测
import QualityTest from '../page/qualityTest/qualityTest'
//  设备申购
import AskList from '../page/askList/askList'
//  设备申请
import Ask from '../page/ask/ask'
//  新增申请
import AskAdd from '../page/askAdd/askAdd'
//  审批/报告
import ReportApproval from '../page/reportApproval/reportApproval'
//  设备验收
import EquipmentAcceptance from '../page/equipmentAcceptance/equipmentAcceptance'
//  验收入库
import PutInStorage from '../page/putInStorage/putInStorage'
//  入库明细
import RKDetailInfo from '../page/rkDetailInfo/rkDetailInfo'
//  验收记录
import History from '../page/history/history'
//  设备入库
import StorageEquipment from '../page/storageEquipment/storageEquipment'
//  设备验收信息
import EquipmentAcceptanceDetails from '../page/equipmentAcceptanceDetails/equipmentAcceptanceDetails'
//  科室报修-搜索
import Search from '../page/search/search'

//  消息
import Message from '@/page/message/message'
//  接单
import OrderReceiving from '@/page/orderReceiving/orderReceiving'
//  派工
import Dispatch from '@/page/dispatch/dispatch'
//  人员搜索
import StaffSearch from '@/page/staffSearch/staffSearch'
//  审批
import Examine from '@/page/examine/examine'
//  验收
import ExamineReceive from '@/page/examineReceive/examineReceive'
//  待处理/处理中
import Pending from '../page/pending/pending'
//  配件搜索
import AccessoriesSearch from '../page/accessoriesSearch/accessoriesSearch'
//  已忽略/已验收/审核未通过
import ServiceDetails from '../page/serviceDetails/serviceDetails'

//  我的
import Me from '@/page/me/me'
//  设置
import Setting from '@/page/setting/setting'
//  医院代码
import HospitalCode from '@/page/hospitalCode/hospitalCode'
//  修改密码
import ChangePassword from '@/page/changePassword/changePassword'
//  关于我们
import About from '../page/about/about'
//仓库选择
import STORE from '../page/STORE/STORE'
//预防性维护验收
import PrecautionreceivingList from '../page/precautionreceivingList_YY/precautionreceivingList'
//预防性维护验收详情
import PrecautionreceivingDefault from '../page/precautionreceivingDefault/precautionreceivingDefault'
//巡检计划实施列表
import PollingimplementList from '../page/pollingimplementList_XS/pollingimplementList'
//巡检实施详情
import PollingimplementDefault_XS from '../page/pollingimplementDefault_XS/pollingimplementDefault_XS'
//巡检计划验收列表
import PollingimacceptanceList from '../page/pollingimacceptanceList_XY/pollingimacceptanceList'
//保养计划实施列表
import MaintainImplementList_BS from '../page/maintainImplementList_BS/maintainImplementList_BS'
//保养计划验收列表
import MaintainImplementList_BY from '../page/maintainImplementList_BY/maintainImplementList_BY'
//保养实施详情
import MaintainImplementDefault from '../page/maintainImplementDefault/maintainImplementDefault'
//申购审批
import SubscribeApply from '../page/Apply/subscribeApply'
//计量列表
import MeteringList from '../page/Metering/MeteringList'
//计量详情
import MeteringDetail from '../page/Metering/MeteringDetail'
//资产修改详情
import PropertyEditDefault from '../page/propertyEditDefault/propertyEditDefault'
//个人详情页
import Personal from '../page/Personal/Personal'
//资产修改列表
import PropertyEditList from '@/page/propertyEditList/propertyEditList'
//维修预处理
import Advance from '@/page/advance/advance'
//医院选择
import Hospital from '../page/Hospital/hospital'
//盘点列表
import InventoryList from '../page/Inventory/InventoryList'
//盘点资产列表
import InventoryDetail from '../page/Inventory/InventoryDetail'
//盘点资产保存
import InventoryEquipment from '../page/Inventory/InventoryEquipment'
//不良事件申报列表
import adverseEventList from '../page/adverseEvent/adverseEventList'
import addAdverseEvent from '../page/adverseEvent/addAdverseEvent'
//供应商协同
import SupplierCollaboration from '../page/supplierCollaboration/index'
import SupplierCollaborationVerify from '../page/supplierCollaboration/verify'

Vue.use(Router)

const _Router = new Router({
    routes: [{
            path: '/Test',
            name: 'Test',
            component: Test
        },
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/me',
            name: 'Me',
            component: Me
        },
        {
            path: '/message',
            name: 'Message',
            component: Message,
        },
        {
            path: '/setting',
            name: 'Setting',
            component: Setting
        },
        {
            path: '/hospitalCode',
            name: 'HospitalCode',
            component: HospitalCode
        },
        {
            path: '/changePassword',
            name: 'ChangePassword',
            component: ChangePassword
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/borrowList',
            name: 'BorrowList',
            component: BorrowList
        },
        {
            path: '/borrowDetails',
            name: 'BorrowDetails',
            component: BorrowDetails
        },
        {
            path: '/orderReceiving',
            name: 'OrderReceiving',
            component: OrderReceiving
        },
        {
            path: '/dispatch',
            name: 'Dispatch',
            component: Dispatch,
        },
        {
            path: '/staffSearch',
            name: 'StaffSearch',
            component: StaffSearch
        },
        {
            path: '/examine',
            name: 'Examine',
            component: Examine,
        },
        {
            path: '/examineReceive',
            name: 'ExamineReceive',
            component: ExamineReceive
        },
        {
            path: '/pending',
            name: 'Pending',
            component: Pending
        },
        {
            path: '/accessoriesSearch',
            name: 'AccessoriesSearch',
            component: AccessoriesSearch
        },
        {
            path: '/serviceDetails',
            name: 'ServiceDetails',
            component: ServiceDetails
        },
        {
            path: '/propertySearch',
            name: 'PropertySearch',
            component: PropertySearch
        },
        {
            path: '/propertyDetails',
            name: 'PropertyDetails',
            component: PropertyDetails
        },
        {
            path: '/repairs',
            name: 'Repairs',
            component: Repairs
        },
        {
            path: '/questionSearch',
            name: 'QuestionSearch',
            component: QuestionSearch
        },
        {
            path: '/repairsList',
            name: 'RepairsList',
            component: RepairsList
        },
        {
            path: '/maintenanceManagement',
            name: 'MaintenanceManagement',
            component: MaintenanceManagement
        },
        {
            path: '/dispatchList',
            name: 'DispatchList',
            component: DispatchList
        },
        {
            path: '/transferOrder',
            name: 'TransferOrder',
            component: TransferOrder
        },
        {
            path: '/transferOrderList',
            name: 'TransferOrderList',
            component: TransferOrderList
        },
        {
            path: '/orderReceivingList',
            name: 'OrderReceivingList',
            component: OrderReceivingList
        },
        {
            path: '/examineReceiveList',
            name: 'ExamineReceiveList',
            component: ExamineReceiveList
        },
        {
            path: '/serviceList',
            name: 'ServiceList',
            component: ServiceList
        },
        {
            path: '/examineList',
            name: 'ExamineList',
            component: ExamineList
        },
        {
            path: '/propertyRecord',
            name: 'PropertyRecord',
            component: PropertyRecord
        },
        {
            path: '/propertyUploadImg',
            name: 'PropertyUploadImg',
            component: PropertyUploadImg,
        },
        {
            path: '/scrapList',
            name: 'ScrapList',
            component: ScrapList,
        },
        {
            path: '/scrap',
            name: 'Scrap',
            component: Scrap,
        },
        {
            path: '/changeDepartment',
            name: 'ChangeDepartment',
            component: ChangeDepartment,
        },
        {
            path: '/changeDepartmentList',
            name: 'ChangeDepartmentList',
            component: ChangeDepartmentList,
        },
        {
            path: '/accessory',
            name: 'Accessory',
            component: Accessory,
        },
        {
            path: '/accessoryList',
            name: 'AccessoryList',
            component: AccessoryList,
        },
        {
            path: '/maintenanceProgress',
            name: 'MaintenanceProgress',
            component: MaintenanceProgress,
        },
        {
            path: '/maintenanceProgressList',
            name: 'MaintenanceProgressList',
            component: MaintenanceProgressList,
        },
        {
            path: '/prevent',
            name: 'Prevent',
            component: Prevent,
        },
        {
            path: '/qualityTest',
            name: 'QualityTest',
            component: QualityTest,
        },
        {
            path: '/askList',
            name: 'AskList',
            component: AskList,
        },
        {
            path: '/askAdd',
            name: 'AskAdd',
            component: AskAdd,
        },
        {
            path: '/ask',
            name: 'Ask',
            component: Ask,
        },
        {
            path: '/reportApproval',
            name: 'ReportApproval',
            component: ReportApproval,
        },
        {
            path: '/equipmentAcceptance',
            name: 'EquipmentAcceptance',
            component: EquipmentAcceptance,
        },
        {
            path: '/history',
            name: 'History',
            component: History,
        },
        {
            path: '/storageEquipment',
            name: 'StorageEquipment',
            component: StorageEquipment,
        },
        {
            path: '/putInStorage',
            name: 'PutInStorage',
            component: PutInStorage,
        },
        {
            path: '/rkDetailInfo',
            name: 'RKDetailInfo',
            component: RKDetailInfo,
        },
        {
            path: '/equipmentAcceptanceDetails',
            name: 'EquipmentAcceptanceDetails',
            component: EquipmentAcceptanceDetails,
        },
        {
            path: '/search',
            name: 'Search',
            component: Search,
        },
        {
            path: '/DeployBorrowListAuditList',
            name: 'DeployBorrowListAuditList',
            component: DeployBorrowListAuditList
        },
        {
            path: '/DeployBorrowAuditDefault',
            name: 'DeployBorrowAuditDefault',
            component: DeployBorrowAuditDefault
        },
        {
            path: '/DeployGiveList',
            name: 'DeployGiveList',
            component: DeployGiveList
        },
        {
            path: '/DeployGiveDefault',
            name: 'DeployGiveDefault',
            component: DeployGiveDefault
        },
        {
            path: '/DeployGiveListAuditList',
            name: 'DeployGiveListAuditList',
            component: DeployGiveListAuditList
        },
        {
            path: '/DeployGiveAuditDefault',
            name: 'DeployGiveAuditDefault',
            component: DeployGiveAuditDefault
        },
        {
            path: '/STORE',
            name: 'STORE',
            component: STORE
        },
        {
            path: '/precautionreceivingList_YY', //预防性维护验收列表
            name: 'PrecautionreceivingList',
            component: PrecautionreceivingList
        },
        {
            path: '/pollingimplementList_XS', //巡检实施列表
            name: 'PollingimplementList',
            component: PollingimplementList
        },
        {
            path: '/pollingimplementDefault_XS', //巡检实施详情
            name: 'PollingimplementDefault_XS',
            component: PollingimplementDefault_XS
        },
        {
            path: '/pollingimacceptanceList_XY', //巡检验收列表
            name: 'PollingimacceptanceList',
            component: PollingimacceptanceList
        },
        {
            path: '/PrecautionreceivingDefault', //验收
            name: 'PrecautionreceivingDefault',
            component: PrecautionreceivingDefault
        },
        {
            path: '/MaintainImplementList_BS', //保养实施列表
            name: 'MaintainImplementList_BS',
            component: MaintainImplementList_BS
        },
        {
            path: '/MaintainImplementList_BY', //保养验收列表
            name: 'MaintainImplementList_BY',
            component: MaintainImplementList_BY
        },
        {
            path: '/MaintainImplementDefault', //保养实施详情
            name: 'MaintainImplementDefault',
            component: MaintainImplementDefault
        },
        {
            path: '/SubscribeApply', //申购审批
            name: 'SubscribeApply',
            component: SubscribeApply
        },
        {
            path: '/MeteringList', //计量列表
            name: 'MeteringList',
            component: MeteringList
        },
        {
            path: '/MeteringDetail', //保养验收列表
            name: 'MeteringDetail',
            component: MeteringDetail
        },
        {
            path: '/propertyEditDefault', //资产修改详情
            name: 'PropertyEditDefault',
            component: PropertyEditDefault
        },
        {
            path: '/Personal', //个人详情页
            name: 'Personal',
            component: Personal
        },
        {
            path: '/propertyEditList', //资产修改列表
            name: 'PropertyEditList',
            component: PropertyEditList
        }, {
            path: '/advance', //维修预处理
            name: 'Advance',
            component: Advance
        }, {
            path: '/hospital', //维修预处理
            name: 'Hospital',
            component: Hospital
        }, {
            path: '/Inventory', ///盘点单列表
            name: 'InventoryList',
            component: InventoryList
        }, {
            path: '/Inventory', //盘点资产列表
            name: 'InventoryDetail',
            component: InventoryDetail
        }, {
            path: '/Inventory', //盘点处理
            name: 'InventoryEquipment',
            component: InventoryEquipment
        }, 
         {
            path: '/adverseEvent', //不良事件申报列表
            name: 'adverseEventList',
            component: adverseEventList
        }, {
            path: '/adverseEvent', //新增不良事件上报
            name: 'addAdverseEvent',
            component: addAdverseEvent
        }, 
         {
            path: '/sup-collab-share', //供应商协同（动态）
            name: 'supCollab',
            component: SupplierCollaborationVerify,
            meta: { public: true }
        }, {
            path: '/sup-collab-share/:id', //供应商协同分享（动态）
            name: 'supCollabShare',
            component: SupplierCollaborationVerify,
            meta: { public: true }
        }, {
            path: '/sup-collab/index/:id', //供应商协同表单（动态）
            name: 'supCollabIndex',
            component: SupplierCollaboration,
            meta: { public: true }
        }
    ]
})


_Router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.public) return next();
    const UserInfoObject = JSON.parse(localStorage.getItem('userInfo'));
    // var dww = Config.HospitalCode;
    if (!localStorage.getItem('HospitalUrl') && to.name !== "Hospital" && !Config
        .PresentType) { //并且医院Url为空  并且当前是app模式
        return next({
            path: 'hospital',
            query: {
                SBBH: to.query.SBBH,
                PXHYBH: to.query.PXHYBH
            }
        });
    } else if ((localStorage.getItem('HospitalUrl') && !Config.PresentType) || Config
        .PresentType) { //当前获取到医院地址并且当前不是app模式
        if (UserInfoObject && to.path.indexOf('login') !== -1) { //跳转首页
            return next({
                path: '/',
                query: {
                    SBBH: to.query.SBBH,
                    PXHYBH: to.query.PXHYBH
                }
            });
        }
        if (!UserInfoObject && to.path.indexOf('login') === -1) { //本地用户信息为空,并且跳转的不是登陆地址
            return next({
                path: 'Login',
                query: {
                    SBBH: to.query.SBBH,
                    PXHYBH: to.query.PXHYBH
                }
            });
        } else if (UserInfoObject && !UserInfoObject.StoreName && to.path.indexOf('STORE') === -1 && to.path
            .indexOf('login') === -1) {
            //本地用户对象的仓库为空,并且跳转的不是仓库地址
            return next({
                path: 'STORE',
                query: {
                    SBBH: to.query.SBBH,
                    PXHYBH: to.query.PXHYBH
                }
            });
        } else if (UserInfoObject && !UserInfoObject.StoreName && to.path.indexOf('STORE') === -1 && to.path
            .indexOf('login') !== -1) {
            localStorage.removeItem('userInfo')
            location.reload();
        } else {
            return next();
        }
    } else if (!localStorage.getItem('HospitalUrl') && to.name !== "Hospital" && Config.PresentType) { //获取不到地址，并且没有到医院页面，并且是H5模式,赋予医院内网地址
        localStorage.setItem('HospitalUrl', Config.H5Path);
    } else
        return next();
})

_Router.afterEach((to, from) => {
    if (from.query.SBBH || from.query.PXHYBH) {
        to.query[from.query.SBBH ? 'SBBH' : 'PXHYBH'] = from.query.SBBH || from.query.PXHYBH;
    }
    if (to.name !== 'Home' && to.name !== 'Message' && to.name !== 'Me') {
        setTimeout(() => {
            const commonBox = document.querySelector('.commonBox')
            commonBox && commonBox.scrollIntoView({
                block: 'start' //元素到页面顶部，其他还有 end, center
            })
        }, 0)
    }
})

export default _Router



// WEBPACK FOOTER //
// ./src/router/index.js